import axios from "axios";
import hmacSHA256 from "crypto-js/hmac-sha256";

const http = axios.create({
  baseURL: import.meta.env.VITE_BACKEND_URL,
});

/**
 * Fetch a list of elements from the specified resource.
 *
 * @param {string} resource The name of the endpoint to call
 * @param {object} options Key-value pair of HTTP options
 * @returns {Promise.<array>} The fetched data
 */
export async function find(resource, options) {
  const headers = createHeaders();
  http.defaults.headers = { ...http.defaults.headers, ...headers };
  const { data } = await http.get(`${resource}`, options);
  return data;
}

export async function findById(resource, id) {
  const headers = createHeaders();
  http.defaults.headers = { ...http.defaults.headers, ...headers };
  const { data } = await http.get(`${resource}/${id}`);
  return data;
}

export async function create(resource, body) {
  const headers = createHeaders();
  http.defaults.headers = { ...http.defaults.headers, ...headers };
  const { data } = await http.post(resource, body);
  return data;
}

export async function search(resource, body) {
  const headers = createHeaders();
  http.defaults.headers = { ...http.defaults.headers, ...headers };
  const { data } = await http.post(resource, body);
  return data;
}

export async function update(resource, id, body) {
  const headers = createHeaders();
  http.defaults.headers = { ...http.defaults.headers, ...headers };
  const { data } = await http.put(`${resource}/${id}`, body);
  return data;
}

export async function remove(resource, id) {
  const headers = createHeaders();
  http.defaults.headers = { ...http.defaults.headers, ...headers };
  const { data } = await http.delete(`${resource}/${id}`);
  return data;
}

function createHeaders() {
  const millis = new Date().getTime();
  const secretKey = millis + "-" + import.meta.env.VITE_OFFSET;
  const signature = createSignature(secretKey);
  return {
    Millis: millis,
    Signature: signature,
  };
}

function createSignature(secretKey) {
  const hmacDigest = hmacSHA256(
    secretKey,
    import.meta.env.VITE_API_KEY
  ).toString();
  return hmacDigest;
}
